import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Field } from 'react-final-form';
import { Row, Col } from 'reactstrap';
// import { LinkContainer } from 'react-router-bootstrap';
// Local Deps
import './InventoryManagementDefinitionForm.scss';
import msgs from '../../../config/messages';
import formConfig from './formConfig';
import NFButton from '../../primitives/NFButton';
// import { inventoryManagementRoute } from '../../../config/navigation/routes';

export default class InventoryManagementDefinitionForm extends Component {
  static propTypes = {
    // formValues: PropTypes.object.isRequired,
    onSubmit: PropTypes.func.isRequired,
    handleInitalValueReset: PropTypes.func.isRequired,
    initialValues: {},
    closeEditModal: PropTypes.func.isRequired,
  };

  static defaultProps = {
    initialValues: {},
  };

  render() {
    const { onSubmit, initialValues, handleInitalValueReset, closeEditModal } = this.props;
    return (
      <div className="nf-tooling-def-form">
        <Form
          onSubmit={onSubmit}
          initialValues={initialValues}
          render={({ handleSubmit, pristine, invalid, submitting, reset }) => (
            <form onSubmit={handleSubmit}>
              {/* <h3>Edit Inventory Management</h3> */}
              <div>
                {formConfig.map((fieldConfig, idx) => (
                  <Field key={idx} {...fieldConfig} />
                ))}
                <Row>
                  <Col className="text-center">
                    <NFButton
                      className="nf-button--gray-border"
                      disabled={submitting}
                      onClick={() => {
                        closeEditModal();
                      }}
                    >
                      {msgs.Form.cancelButton}
                    </NFButton>
                    <NFButton
                      className="nf-button--gray-border"
                      onClick={() => {
                        handleInitalValueReset();
                        reset(initialValues);
                      }}
                      disabled={submitting}
                    >
                      Reset
                    </NFButton>
                    <NFButton id='button'
                      className="nf-button--form nf-button--orange"
                      type="submit"
                      disabled={pristine || invalid || submitting}
                    >
                      {msgs.Form.submitButton}
                    </NFButton>
                  </Col>
                </Row>
              </div>
            </form>
          )}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/forms/InventoryManagementDefinitionForm/InventoryManagementDefinitionForm.jsx